$ = jQuery.noConflict();

function CenterImage(pTarget){
	var _target = pTarget;
	var _container = pTarget.parent();
	
	//console.log("NEW CENTER IMAGE -> " +pTarget.attr("class"));
	
	var _ratio = _target.width() / _target.height();
	//console.log("NEW CENTER IMAGE : " + _ratio);
	
	
	
	$(window).resize(function(){
		resize_image();
	})
	
	resize_image();
	
	function resize_image(){
		var wDest;
		var hDest;
		var xDest;
		var yDest;
		
		var wCont = _container.outerWidth();
		var hCont = _container.outerHeight();
		
		//console.log("RESIZE IMAGE " + _container.parent().index() + " -> wCont = " + wCont + " hCont = " + hCont);
		
		//CALAGE SUR LA LARGEUR
		wDest = Math.round(wCont);
		hDest = Math.round(wDest / _ratio);
		
		if(hDest < hCont){
			
			// CALAGE SUR LA HAUTEUR
			hDest = Math.round(hCont);
			wDest = Math.round(hDest * _ratio);
		}
		
		
		// POSITION X Y
		xDest = Math.round(( wCont - wDest)/2);
		yDest = Math.round(( hCont - hDest)/2);
		
		
		//console.log("RESIZE IMAGE " + _container.parent().index() + " -> wDest = " + wDest + " hDest = " + hDest + "    || x/y = " + xDest + " x " + yDest );
		
		_target.css({width:wDest, height:hDest, left:xDest, top:yDest, "max-width":"none"});
		
	}
}


$(document).ready(function(){
	$('.center-image').each(function (i, elt) {
		var _centerImage = new CenterImage($(this));
	});
});
